module.exports = __webpack_public_path__ + "static/media/Property 1=Titan.985a6701.png";